import * as React from 'react';

var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgZignalyIsotype = function SvgZignalyIsotype(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3814 9.75401C30.8544 9.75401 32 10.9519 32 12.492V18.139C32 19.6791 30.8544 20.877 29.3814 20.877C27.9085 20.877 26.7628 19.6791 26.7628 18.139V12.492C26.7628 10.9519 27.9085 9.75401 29.3814 9.75401ZM22.8349 13.4332C24.3079 13.4332 25.4535 14.631 25.4535 16.1711V25.8396C25.4535 27.3797 24.3079 28.5775 22.8349 28.5775C21.362 28.5775 20.2164 27.3797 20.2164 25.8396V16.1711C20.2164 14.631 21.362 13.4332 22.8349 13.4332ZM15.9611 2.31016C17.4341 2.31016 18.5797 3.50802 18.5797 5.04813V29.262C18.5797 30.8021 17.4341 32 15.9611 32C14.4882 32 13.3426 30.8021 13.3426 29.262V5.04813C13.3426 3.50802 14.4882 2.31016 15.9611 2.31016ZM9.41468 0C10.8876 0 12.0333 1.19786 12.0333 2.73797V16.0856C12.0333 17.6257 10.8876 18.8235 9.41468 18.8235C7.94172 18.8235 6.79609 17.6257 6.79609 16.0856V2.73797C6.79609 1.28342 7.94172 0 9.41468 0ZM2.54088 9.49733C4.01384 9.49733 5.15947 10.6952 5.15947 12.2353V19.0802C5.15947 20.6203 4.01384 21.8182 2.62271 21.8182C1.14976 21.8182 0.00412551 20.6203 0.00412551 19.1658V19.0802V12.2353C-0.0777054 10.6952 1.06793 9.49733 2.54088 9.49733Z",
    fill: "url(#paint0_linear_1203_7683)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1203_7683",
    x1: 27.7008,
    y1: 25.0139,
    x2: 2.90077,
    y2: 7.14064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#11CED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4053C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7D33D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CF61DC"
  })))));
};

export { SvgZignalyIsotype as ReactComponent };
